<img src="https://finviz.com/chart.ashx?t={{symbol}}&ty=c&ta=1&p=d&s=l">
